import React, { useState, useEffect } from "react";
import "./Settlement.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import jsPDF from "jspdf";

const Settlement = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
 useEffect(() => {
    if(sessionStorage.getItem("login") !== "true"){
      navigate("/")
    }
  }, [])
  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (!month) return;

    const fetchActionPlan = async () => {
      try {
        const q = query(
          collection(db, "actionplan"),
          where("empid", "==", empId),
          where("month", "==", String(month + " " + year)),
          where("cs", "==", 1)
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setActionPlan([]);
          return;
        }

        const actions = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          actions.push({
            id: doc.id,
            code: data.programCode || "",
            text: data.program || "",
            acsettlement: data.acsettlement || "",
          });
        });

        setActionPlan(actions);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year]);

  const fetchSettlementData = async (id) => {
    try {
      const docRef = doc(db, "actionplan", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.error("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      return null;
    }
  };

  const handleDownloadPDF = async (id) => {
    const docRef1 = doc(db, "actionplan", id);
    const docSnap1 = await getDoc(docRef1);
    if (docSnap1.data().vcapproval == "No") {
      const docRef = doc(db, "empmaster", empId);
      const docSnap = await getDoc(docRef);
      const empData = docSnap.data();
      const { name, desig, signature: base64Signature } = empData;

      const data = await fetchSettlementData(id);
      if (!data) return;

      const { scm, scf, stm, stf, othm, othf } = data;
      const pdf = new jsPDF("p", "mm", "a4");


      const img = new Image();
      if (empId == '1' || empId == '2' || empId == '3' || empId == '4' || empId == '5' || empId == '6') {
        img.src = "/assets/kalimpong.jpg";
      }
      if (empId == '7' || empId == '8' || empId == '9' || empId == '10' || empId == '11' || empId == '12') {
        img.src = "/assets/coochbehar.jpg";
      }
      if (empId == '13' || empId == '14' || empId == '15' || empId == '16' || empId == '17' || empId == '18') {
        img.src = "/assets/uttardinajpur.jpg";
      }
      if (empId == '19' || empId == '20' || empId == '21' || empId == '22' || empId == '23' || empId == '24') {
        img.src = "/assets/dakshindinajpur.jpg";
      }
      if (empId == '25' || empId == '26' || empId == '27' || empId == '28' || empId == '29' || empId == '30') {
        img.src = "/assets/malda.jpg";
      }
      const demandDate = data.demanddate?.toDate ? data.demanddate.toDate().toLocaleDateString("en-GB") : "N/A";
      const ddoDate = data.ddodate?.toDate ? data.ddodate.toDate().toLocaleDateString("en-GB") : "N/A";
      const deeDate = data.deedate?.toDate ? data.deedate.toDate().toLocaleDateString("en-GB") : "N/A";

      img.onload = () => {
        pdf.addImage(img, "JPG", 0, 0, 210, 297);

        pdf.setFont("helvetica");
        pdf.setFontSize(12);

        pdf.text(`${data.programCode || "N/A"}`, (650 / 300) * 25.4, (610 / 300) * 25.4);
        pdf.text(`${data.budgethead || "N/A"}`, (1550 / 300) * 25.4, (610 / 300) * 25.4);
        pdf.text(`${data.program || "N/A"}`, (640 / 300) * 25.4, (670 / 300) * 25.4);
        pdf.text(`${name || "N/A"}`, (1400 / 300) * 25.4, (1228 / 300) * 25.4);
        pdf.text(`${desig || "N/A"}`, (1493 / 300) * 25.4, (1295 / 300) * 25.4);

        // Add signature directly from Base64 if it exists
        if (base64Signature) {
          pdf.addImage(base64Signature, "PNG", (1450 / 300) * 25.4, (940 / 300) * 25.4, 40, 20);
        } else {
          console.error("Signature is missing in the empmaster document.");
        }

        pdf.text(`${data.budgetdemand || 0}`, 60, 65);
        pdf.text(`Total Amount: Rs.${data.totamount || 0}`, 60, 90);
        pdf.text(`${demandDate || 0}`, 34, 99);
        pdf.text(`${demandDate || 0}`, 34, 129);
        pdf.text(`${data.ddoremarks || 0}`, 58, 146);
        pdf.text(`${ddoDate || 0}`, 34, 169);
        pdf.text(`${ddoDate || 0}`, 34, 191);
        pdf.text(`${data.deeremarks || 0}`, 58, 204);
        pdf.text(`${deeDate || 0}`, 36, 224);

        pdf.save(`Settlement_${id}.pdf`);
      }
    }
    else {
      var link = document.createElement('a');
      link.href = docSnap1.data().vcapproval;
      link.download = `VCApproval_${id}.pdf`
      link.dispatchEvent(new MouseEvent('click'));
    }
  };
  const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Account Settlement of {name || "User"}</h1>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select className="dropdown" value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        &nbsp;
        <select className="dropdown" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: "150px", height: "40px", marginTop: "33px" }}>
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th>Program Code</th>
                <th>Program Name</th>
                <th>Settlement Status</th>
                <th>Download Notesheet</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action) => (
                <tr key={action.id}>
                  <td>{action.code}</td>
                  <td>{action.text}</td>
                  <td>{action.acsettlement}</td>
                  <td><button onClick={() => handleDownloadPDF(action.id)}>Download</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
              <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />

    </div>
  );
};

export default Settlement;
